export default __webpack_public_path__ + "static/media/news75.f88e8ed5.jpg";